/**
 * Calcul des jours fériés français
 *
 * Inclut les jours fixes + les jours mobiles calculés
 * via l'algorithme de Meeus/Jones/Butcher pour Pâques.
 */

/** Retourne la liste des jours fériés français pour une année donnée (format YYYY-MM-DD) */
export const getFrenchHolidays = (year: number): string[] => {
  const pad = (n: number) => String(n).padStart(2, '0');

  const holidays = [
    `${year}-01-01`, // Jour de l'an
    `${year}-05-01`, // Fête du travail
    `${year}-05-08`, // Victoire 1945
    `${year}-07-14`, // Fête nationale
    `${year}-08-15`, // Assomption
    `${year}-11-01`, // Toussaint
    `${year}-11-11`, // Armistice
    `${year}-12-25`, // Noël
  ];

  // Algorithme de Meeus/Jones/Butcher pour le dimanche de Pâques
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  const easter = new Date(year, month - 1, day);

  const addDaysStr = (date: Date, days: number): string => {
    const res = new Date(date);
    res.setDate(res.getDate() + days);
    return `${res.getFullYear()}-${pad(res.getMonth() + 1)}-${pad(res.getDate())}`;
  };

  holidays.push(addDaysStr(easter, 1));  // Lundi de Pâques
  holidays.push(addDaysStr(easter, 39)); // Ascension
  holidays.push(addDaysStr(easter, 50)); // Lundi de Pentecôte

  return holidays;
};
